// extracted by mini-css-extract-plugin
export default {"nav":"nav--pRbeC","listItem":"listItem--xnpoU","spaceAfter":"spaceAfter--f3gk5","item":"item--hT7t5","link":"link--_2tDK","inactiveLink":"inactiveLink--mdZpd","lock":"lock--kVGun"};